import { useEffect, useState } from 'react';
import { api } from './apiClient.js';

/**
 * מצב חיבור אמיתי: navigator.onLine בלבד לא אמין (מזהה רק ניתוק שכבת-קישור,
 * לא אובדן קישוריות בפועל). מוסיפים בדיקת health תקופתית קלה כאשר "מקוון" לפי הדפדפן.
 */
export function useOnlineStatus(): boolean {
  const [browserOnline, setBrowserOnline] = useState(navigator.onLine);
  const [serverReachable, setServerReachable] = useState(true);

  useEffect(() => {
    const onOnline = () => setBrowserOnline(true);
    const onOffline = () => setBrowserOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  useEffect(() => {
    if (!browserOnline) {
      setServerReachable(false);
      return;
    }
    let cancelled = false;
    const check = async () => {
      try {
        await api.get('/api/health');
        if (!cancelled) setServerReachable(true);
      } catch {
        if (!cancelled) setServerReachable(false);
      }
    };
    check();
    const id = window.setInterval(check, 15_000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [browserOnline]);

  return browserOnline && serverReachable;
}
